import { useNode } from "@craftjs/core";
import React, { useState } from "react";

import { TextActiveIcon } from "../../../assets/ui-icons";
import RightBar from "../../ui-kit/rightbar";

export const CMSHTMLSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
  }));

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar cursor-default p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full ">
        <div className="p-5 flex justify-between rounded-t-[21px] bg-white">
          <RightBar title={"Custom HTML"} icon={<TextActiveIcon />} />
        </div>
        <div className="text-xs text-gray-500 flex-1 min-h-[60vh] flex items-center bg-white justify-center text-center rounded-b-[21px]">
          No Settings Available.
        </div>
        {/* <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} /> */}
        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
